import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import moduleBreadcrumbs from '../../moduleBreadcrumbs';

export default [
  ...buildCrudRoutes({
    baseName: 'antiFraud',
    basePath: 'ant-fraud',
    card: {
      title: 'Clientes infratores da regra',
      icon: 'account-alert-outline',
    },
    moduleActive: 'contacard',
    subModuleActive: 'limits',
    moduleGroupName: 'limits',
    baseBreadcrumbs: [
      ...moduleBreadcrumbs,
    ],
    listRoute: {
      pageContent: () => import('Modules/contacard/limits/antiFraud/AntiFraduList.vue'),
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      searchOptions: { label: 'Buscar infrator', searchAttribute: 'search' },
      pageTitle: 'Clientes infratores da regra',
      navigateBackRoute: 'contacard.submodules.list',
    },
    editRoute: {
      component: () => import('Modules/contacard/limits/antiFraud/AntiFraudForm.vue'),
      breadcrumbs: [
        {
          text: 'Visualizar detalhes',
          disabled: true,
        },
      ],
    },
  }),
];
